import React from 'react';
import { message, Icon } from 'antd';
import { CB_STATUS } from './cFetch';

export const msgCB = (
  status,
  formatMessage,
  conf = {
    all: true,
    SUCCESS: true,
    UNREACH: true,
    TIMEOUT: true,
    UNAUTH: true,
    DEFAULT: true,

  },
) => {
  const config = {

    SUCCESS: conf.all,
    UNREACH: conf.all,
    TIMEOUT: conf.all,
    UNAUTH: conf.all,
    DEFAULT: conf.all,
    ...conf,
  };
  message.config({
    top: 100,
    icon: <Icon type="check-circle" theme="filled" />
      ? status === CB_STATUS.SUCCESS : <Icon type="close-circle" theme="filled" />,
  });
  switch (status) {
    case CB_STATUS.SUCCESS:
    case CB_STATUS.SUCCESSAndLogout:
      if (config.SUCCESS) {
        message.success(
          formatMessage({
            id: 'app.operation.success',
            defaultMessage: 'operation successful',
          }),
        );
      }
      break;
    case CB_STATUS.UNREACH:
      if (config.UNREACH) {
        message.error(
          formatMessage({
            id: 'app.fetch.serverUnavailable',
            defaultMessage: 'server unavailable',
          }),
        );
      }
      break;
    case CB_STATUS.TIMEOUT:
      if (config.TIMEOUT) {
        message.error(
          formatMessage({
            id: 'app.fetch.timeout',
            defaultMessage: 'operation timeout',
          }),
        );
      }
      break;
    case CB_STATUS.UNAUTH:
      if (config.UNAUTH) {
        message.error(
          formatMessage({
            id: 'app.fetch.invalidToken',
            defaultMessage: 'please login again',
          }),
        );
      }
      break;
    case CB_STATUS.MAXLIMITDevice:
      message.error(
        formatMessage({
          id: 'Device.maxlimit',
          defaultMessage: 'Maximum device added, please delete old one',
        }),
      );
      break;
    case CB_STATUS.MAXLIMITAcc:
      message.error(
        formatMessage({
          id: 'Account.maxlimit',
          defaultMessage: 'Maximum account added, please delete old one',
        }),
      );
      break;
    default:
      if (config.DEFAULT) {
        message.error(
          formatMessage({
            id: 'app.operation.fail',
            defaultMessage: 'operation failure',
          }),
        );
      }
      break;
  }
};

export const MSG_TYPE = {
  WARNING: 'WARNING',
  ERR: 'ERR',
  SUCCESS: 'SUCCESS',
};

export const msgPop = (msg, type = MSG_TYPE.WARNING, duration = 3) => {
  message.destroy();
  switch (type) {
    case MSG_TYPE.SUCCESS:
      message.success(msg, duration);
      break;
    case MSG_TYPE.ERR:
      message.error(msg, duration);
      break;
    default:
      message.warning(msg, duration);
      break;
  }
};
